import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

class CommunityActionPage extends Component {
  render() {
    return (
      <div className='page community-action'>
        <h1>
          <FormattedMessage id="page.community_action.title" />
        </h1>

        <FormattedHTMLMessage id="page.community_action.content" />

      </div>
    )
  }
}

export default CommunityActionPage;



// WEBPACK FOOTER //
// ./src/pages/CommunityActionPage.js